import React from 'react';
import { Panel, Button, Label } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { mapStatusToLabel } from '../paymentHistory/utils';
import LabelWithTooltip from '../../common/components/LabelWithTooltip';

const renderTotalCell = (remainingTotal, row) => {
	return ui.formatAmount(remainingTotal) + (row.refundedTotal ? ` (${ui.formatAmount(row.refundedTotal)})` : '');
};

const detailsLink = (id, parentId) => parentId ? `/individualConsultations/${id}/${parentId}/details` : `/individualConsultations/${id}/0/details`;

const List = ({ isReadonly, parentId, t, canSendMessage, listActions, ...rest }) => {
	const columns = [
		{
			header: t('IndividualConsultation_Id'),
			accessor: 'id',
			cell: (id, row) => (<Link to={detailsLink(id, parentId)} >
				{id}&nbsp;
				{row.isPaymentError && !row.isInactive && <LabelWithTooltip id='еrrorTooltip' tooltip={t('PaymentHistory_ErrorTooltip')}><FontAwesomeIcon style={{ color: 'yellow' }} icon={faTriangleExclamation} /></LabelWithTooltip>}
			</Link>),
			sortable: true
		}];
	if (!parentId || parentId === 0) {
		columns.push({
			header: t('IndividualConsultation_Parent'),
			accessor: 'parent.fullname',
			cell: (parent, row) => {
				if (parentId > 0) {
					return row.parent.fullname;
				}
				else {
					return <Link to={`/parents/${row.parent.id}`} > {row.parent.fullname}</Link>;
				}
			},
			sortable: true
		})
	}
	columns.push({
		header: t('IndividualConsultation_Child'),
		accessor: 'child.fullname',
		cell: (child, row) => {
			if (parentId > 0) {
				return row.child.fullname;
			}
			else {
				return <Link to={`/parents/${row.parent.id}/children/${row.child.id}`} > {row.child.fullname}</Link>;
			}
		},
		sortable: true
	});
	columns.push({
		header: t('IndividualConsultation_Center'),
		accessor: 'center.name',
		sortable: true
	});
	columns.push({
		header: t('IndividualConsultation_Type'),
		accessor: 'type',
		cell: (type) => t(`IndividualConsultationType_${type.name}`),
		sortable: true
	});
	columns.push({
		header: t('IndividualConsultation_ConsultationDate'),
		accessor: 'consultationDate',
		sortable: true,
		cell: (consultationDate) => (ui.formatDateTime(consultationDate))
	});
	columns.push({
		header: t('PaymentHistory_Total'),
		accessor: 'remainingTotal',
		sortable: true,
		cell: renderTotalCell
	});
	columns.push({
		header: t('PaymentHistory_PaidTotal'),
		accessor: 'paidTotal',
		sortable: false
	});
	columns.push({
		header: t('PaymentHistory_OutstandingTotal'),
		accessor: 'outstandingTotal',
		sortable: false
	});
	columns.push({
		header: t('PaymentHistory_Status'),
		accessor: 'status',
		cell: (status, row) => <span> <Label bsStyle={mapStatusToLabel(status.id)}>{t(`PaymentStatusType_${status.name}`)}</Label> {row.isInactive && <Label bsStyle='inverse'>{t('PaymentStatus_Inactive')}</Label>}</span>,
		sortable: true
	});
	columns.push({
		header: t('PaymentHistory_Created'),
		accessor: 'created',
		sortable: true,
		cell: (created) => (ui.formatDateTime(created))
	});
	columns.push({
		header: t('PaymentHistory_PaymentDate'),
		accessor: 'paymentDate',
		sortable: true,
		cell: (paymentDate) => (ui.formatDateTime(paymentDate))
	})
	columns.push({
		header: t('PaymentHistory_PaymentMethod'),
		accessor: 'paymentMethod',
		sortable: true,
		cell: (paymentMethod) => (paymentMethod ? paymentMethod.name : '')
	});
	columns.push({
		header: t('Common_Actions'),
		accessor: 'id',
		cell: (id) => (<Link to={detailsLink(id, parentId)} className='btn btn-teal'><FontAwesomeIcon icon={faEye} /> {t('Common_View')}</Link>)
	});

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} checkboxSelection={!parentId && canSendMessage} listActions={listActions} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);